var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.94 22.6496C10.46 22.6496 9.98999 22.5296 9.54999 22.2896C8.66999 21.7996 8.13999 20.9096 8.13999 19.9096V14.6096C8.13999 14.1096 7.80999 13.3596 7.49999 12.9796L3.75999 9.01961C3.12999 8.38961 2.64999 7.30961 2.64999 6.49961V4.19961C2.64999 2.59961 3.85999 1.34961 5.39999 1.34961H18.6C20.12 1.34961 21.35 2.57961 21.35 4.09961V6.29961C21.35 7.34961 20.72 8.53961 20.13 9.12961L15.8 12.9596C15.38 13.3096 15.05 14.0796 15.05 14.6996V18.9996C15.05 19.8896 14.49 20.9196 13.79 21.3396L12.41 22.2296C11.96 22.5096 11.45 22.6496 10.94 22.6496ZM5.39999 2.84961C4.69999 2.84961 4.14999 3.43961 4.14999 4.19961V6.49961C4.14999 6.86961 4.44999 7.58961 4.82999 7.96961L8.63999 11.9796C9.14999 12.6096 9.64999 13.6596 9.64999 14.5996V19.8996C9.64999 20.5496 10.1 20.8696 10.29 20.9696C10.71 21.1996 11.22 21.1996 11.61 20.9596L13 20.0696C13.28 19.8996 13.56 19.3596 13.56 18.9996V14.6996C13.56 13.6296 14.08 12.4496 14.83 11.8196L19.11 8.02961C19.45 7.68961 19.86 6.87961 19.86 6.28961V4.09961C19.86 3.40961 19.3 2.84961 18.61 2.84961H5.39999Z",
    fill: "#868484"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.00001 10.7503C5.86001 10.7503 5.73001 10.7103 5.60001 10.6403C5.25001 10.4203 5.14001 9.95026 5.36001 9.60026L10.29 1.70026C10.51 1.35026 10.97 1.24026 11.32 1.46026C11.67 1.68026 11.78 2.14026 11.56 2.49026L6.63001 10.3903C6.49001 10.6203 6.25001 10.7503 6.00001 10.7503Z",
    fill: "#868484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.c642ec5fa4c15eaa319ee910df0cd476.svg";
export { ForwardRef as ReactComponent };